module.exports = __webpack_public_path__ + "img/time_calc.93b79b23.svg";